export function MarkerIcon(type, color, size = 'm') {

  const pixelSize = markerSizes[size] || markerSizes['m'] || 32;

  switch (type) {
    case 'modern':
      return (
        <div className="relative" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Ana daire */}
            <circle cx="16" cy="16" r="10" fill={color || '#EA4335'} stroke="#B71C1C" strokeWidth="1.5" />
            {/* Alt çubuk */}
            <rect x="14.5" y="24" width="3" height="8" rx="1.2" fill="#B71C1C" />
            {/* Ok ucu */}
            <path d="M 11 32 L 16 40 L 21 32 Z" fill="#B71C1C" />
            {/* Gölge */}
            <ellipse cx="16" cy="40" rx="6" ry="1.5" fill="#000" opacity="0.12" />
          </svg>
        </div>
      );
    case 'arrow':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <line x1="16" y1="6" x2="16" y2="22" stroke={color || "#ef4444"} strokeWidth="5" strokeLinecap="round" />
            <polygon points="16,26 8,18 24,18" fill={color || "#ef4444"} />
          </svg>
        </div>
      );
    case 'book':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <rect x="8" y="6" width="4" height="20" fill={color || "#ef4444"} rx="1" />
            <path d="M12 6h12c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H12V6z" fill="white" stroke={color || "#ef4444"} strokeWidth="1.5" />
            <line x1="16" y1="10" x2="22" y2="10" stroke={color || "#ef4444"} strokeWidth="1.5" />
            <line x1="16" y1="14" x2="22" y2="14" stroke={color || "#ef4444"} strokeWidth="1.5" />
            <line x1="16" y1="18" x2="22" y2="18" stroke={color || "#ef4444"} strokeWidth="1.5" />
          </svg>
        </div>
      );
    case 'flag':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <line x1="8" y1="4" x2="8" y2="28" stroke={color || "#ef4444"} strokeWidth="2" strokeLinecap="round" />
            <path d="M8 6C8 6 10 4 16 4C22 4 24 6 24 6V16C24 16 22 14 16 14C10 14 8 16 8 16V6Z" fill={color || "#ef4444"} />
          </svg>
        </div>
      );
    case 'mosque':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Sol minare - yüksekliği 2 kat */}
            <rect x="7" y="4" width="2" height="20" fill={color || "#F5DEB3"} stroke="#D2B48C" strokeWidth="0.5" />
            <ellipse cx="8" cy="4" rx="1.5" ry="1" fill="#4682B4" stroke="#2F4F4F" strokeWidth="0.3" />
            <path d="M 7.2 2.5 Q 8 2 8.8 2.5 Q 8.4 3 8 2.5 Q 7.6 3 7.2 2.5" fill="#FFD700" stroke="#DAA520" strokeWidth="0.2" />
            {/* Sağ minare - yüksekliği 2 kat */}
            <rect x="23" y="4" width="2" height="20" fill={color || "#F5DEB3"} stroke="#D2B48C" strokeWidth="0.5" />
            <ellipse cx="24" cy="4" rx="1.5" ry="1" fill="#4682B4" stroke="#2F4F4F" strokeWidth="0.3" />
            <path d="M 23.2 2.5 Q 24 2 24.8 2.5 Q 24.4 3 24 2.5 Q 23.6 3 23.2 2.5" fill="#FFD700" stroke="#DAA520" strokeWidth="0.2" />
            {/* Ana cami binası */}
            <rect x="9" y="14" width="14" height="10" fill={color || "#F5DEB3"} stroke="#D2B48C" strokeWidth="0.7" />
            {/* Ana kubbe */}
            <ellipse cx="16" cy="14" rx="7" ry="4" fill="#4682B4" stroke="#2F4F4F" strokeWidth="0.7" />
            {/* Kubbe üstündeki hilal */}
            <path d="M 15.2 10 Q 16 9.2 16.8 10 Q 16.4 10.5 16 10 Q 15.6 10.5 15.2 10" fill="#FFD700" stroke="#DAA520" strokeWidth="0.2" />
            {/* Ana giriş kapısı */}
            <path d="M 12 24 L 12 19 Q 12 17 16 17 Q 20 17 20 19 L 20 24 Z" fill="#8B4513" stroke="#654321" strokeWidth="0.5" />
            {/* Kapı süslemesi */}
            <rect x="14" y="20" width="4" height="4" fill="#A0522D" stroke="#654321" strokeWidth="0.2" />
            <circle cx="16" cy="22" r="0.5" fill="#FFD700" />
            {/* Pencereler */}
            <circle cx="12" cy="17" r="1" fill="#87CEEB" stroke="#2F4F4F" strokeWidth="0.4" />
            <circle cx="20" cy="17" r="1" fill="#87CEEB" stroke="#2F4F4F" strokeWidth="0.4" />
            {/* Pencere çerçeveleri */}
            <circle cx="12" cy="17" r="0.7" fill="none" stroke="#654321" strokeWidth="0.2" />
            <circle cx="20" cy="17" r="0.7" fill="none" stroke="#654321" strokeWidth="0.2" />
          </svg>
        </div>
      );
    case 'bridge':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Sol kule - daha kalın ve yüksek */}
            <rect x="5.5" y="6" width="4" height="16" fill={color || "#ef4444"} stroke="#b91c1c" strokeWidth="1" />
            {/* Sol kule üst katman */}
            <rect x="6.5" y="3.5" width="2" height="3" fill="#fff" stroke="#b91c1c" strokeWidth="0.7" />
            {/* Sol kule tepe */}
            <rect x="7.2" y="2" width="0.6" height="2" fill={color || "#b91c1c"} />
            {/* Sol kemer */}
            <path d="M7.5 22 Q8.5 18 9.5 22" stroke="#b91c1c" strokeWidth="1.2" fill="none" />
            {/* Sağ kule - daha kalın ve yüksek */}
            <rect x="22.5" y="6" width="4" height="16" fill={color || "#ef4444"} stroke="#b91c1c" strokeWidth="1" />
            {/* Sağ kule üst katman */}
            <rect x="23.5" y="3.5" width="2" height="3" fill="#fff" stroke="#b91c1c" strokeWidth="0.7" />
            {/* Sağ kule tepe */}
            <rect x="24.2" y="2" width="0.6" height="2" fill={color || "#b91c1c"} />
            {/* Sağ kemer */}
            <path d="M24.5 22 Q25.5 18 26.5 22" stroke="#b91c1c" strokeWidth="1.2" fill="none" />
            {/* Üst yürüyüş yolu - daha kalın */}
            <rect x="9.5" y="11" width="13" height="2" fill={color || "#ef4444"} stroke="#b91c1c" strokeWidth="0.7" />
            {/* Alt ana yol - daha kalın */}
            <rect x="9.5" y="20" width="13" height="2.5" fill={color || "#ef4444"} stroke="#b91c1c" strokeWidth="0.7" />
            {/* Dikey destekler - daha kalın */}
            <rect x="11" y="13" width="0.7" height="7" fill="#b91c1c" />
            <rect x="13" y="13" width="0.7" height="7" fill="#b91c1c" />
            <rect x="15" y="13" width="0.7" height="7" fill="#b91c1c" />
            <rect x="17" y="13" width="0.7" height="7" fill="#b91c1c" />
            <rect x="19" y="13" width="0.7" height="7" fill="#b91c1c" />
            <rect x="21" y="13" width="0.7" height="7" fill="#b91c1c" />
          </svg>
        </div>
      );
    case 'house':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Çatı */}
            <path d="M6 16L16 6L26 16" stroke={color || "#ef4444"} strokeWidth="2" fill={color || "#ef4444"} />
            {/* Ana bina */}
            <rect x="8" y="16" width="16" height="12" fill="white" stroke={color || "#ef4444"} strokeWidth="2" />
            {/* Kapı */}
            <rect x="14" y="20" width="4" height="8" fill={color || "#ef4444"} />
            {/* Pencereler */}
            <rect x="10" y="18" width="3" height="3" fill={color || "#ef4444"} />
            <rect x="19" y="18" width="3" height="3" fill={color || "#ef4444"} />
            {/* Baca */}
            <rect x="20" y="8" width="2" height="4" fill={color || "#ef4444"} />
          </svg>
        </div>
      );
    case 'horse':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Gövde */}
            <ellipse cx="16" cy="20" rx="8" ry="4" fill={color || "#ef4444"} />
            {/* Göğüs */}
            <ellipse cx="9.5" cy="17" rx="3.2" ry="4" fill={color || "#ef4444"} />
            {/* Boyun */}
            <ellipse cx="7" cy="12" rx="1.7" ry="4.5" fill={color || "#ef4444"} />
            {/* Baş */}
            <ellipse cx="4.5" cy="7.5" rx="2.2" ry="2.7" fill={color || "#ef4444"} />
            {/* Burun */}
            <ellipse cx="2.8" cy="9.5" rx="0.8" ry="1.2" fill={color || "#ef4444"} />
            {/* Kulaklar */}
            <ellipse cx="4.1" cy="5.2" rx="0.4" ry="1" fill={color || "#ef4444"} />
            <ellipse cx="5" cy="5.2" rx="0.4" ry="1" fill={color || "#ef4444"} />
            {/* Ön bacaklar */}
            <rect x="9" y="24" width="1.2" height="6" rx="0.6" fill="#b91c1c" />
            <rect x="11" y="24" width="1.2" height="6" rx="0.6" fill="#b91c1c" />
            {/* Arka bacaklar */}
            <rect x="22" y="24" width="1.2" height="6" rx="0.6" fill="#b91c1c" />
            <rect x="24" y="24" width="1.2" height="6" rx="0.6" fill="#b91c1c" />
            {/* Toynaklar */}
            <ellipse cx="9.6" cy="30.5" rx="0.7" ry="0.3" fill="#222" />
            <ellipse cx="11.6" cy="30.5" rx="0.7" ry="0.3" fill="#222" />
            <ellipse cx="22.6" cy="30.5" rx="0.7" ry="0.3" fill="#222" />
            <ellipse cx="24.6" cy="30.5" rx="0.7" ry="0.3" fill="#222" />
            {/* Kuyruk */}
            <path d="M 25 20 Q 27 21 28.5 22.5 Q 30 24 30.5 26 Q 31 28 30.5 29.5 Q 30 31 29 31 Q 28 31 27.5 30 Q 27 29 27.2 28 Q 27.4 27 27.6 26 Q 27.8 25 27.2 24 Q 26.6 23 25 20 Z" fill="#b91c1c" />
            {/* Göz */}
            <circle cx="4.1" cy="7.2" r="0.2" fill="#222" />
            {/* Burun deliği */}
            <ellipse cx="2.5" cy="10" rx="0.15" ry="0.2" fill="#222" />
          </svg>
        </div>
      );
    case 'ship':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Vapur gövdesi */}
            <rect x="8" y="18" width="16" height="6" rx="2" fill={color || "#ef4444"} stroke="#b91c1c" strokeWidth="0.7" />
            {/* Üst kat */}
            <rect x="12" y="15" width="8" height="3" fill="#fff" stroke="#b91c1c" strokeWidth="0.5" />
            {/* Bacası */}
            <rect x="15" y="12" width="2" height="3" fill="#b91c1c" />
            {/* Pencere */}
            <circle cx="14" cy="19" r="0.7" fill="#fff" />
            <circle cx="16" cy="19" r="0.7" fill="#fff" />
            <circle cx="18" cy="19" r="0.7" fill="#fff" />
            <circle cx="20" cy="19" r="0.7" fill="#fff" />
            {/* Dalga */}
            <path d="M8 24 Q10 26 12 24 Q14 22 16 24 Q18 26 20 24 Q22 22 24 24 Q26 26 24 28 Q22 30 20 28 Q18 26 16 28 Q14 30 12 28 Q10 26 8 28" stroke="#3b82f6" strokeWidth="0.7" fill="none" />
          </svg>
        </div>
      );
    case 'explosion':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Ana bomba gövdesi */}
            <circle cx="16" cy="22" r="8" fill="#222" stroke={color || "#ef4444"} strokeWidth="1.5" />

            {/* Bombanın parlaklık efekti */}
            <circle cx="14" cy="20" r="2" fill="#444" opacity="0.6" />

            {/* Fitil kısmı */}
            <path
              d="M 16 14 Q 14 12 15 10 Q 16 8 14 6"
              fill="none"
              stroke="#555"
              strokeWidth="1.2"
              strokeLinecap="round"
            />

            {/* Fitil ucundaki ateş */}
            <path
              d="M 13 4 Q 14 3 15 4 Q 16 5 14 6 Q 13 7 13 4"
              fill={color || "#ef4444"}
            />
            <path
              d="M 13.5 2.5 Q 14 2 14.5 2.5 Q 15 3 14 3.5 Q 13 4 13.5 2.5"
              fill="#ff8c00"
            />

            {/* Bombanın vidalı kapağı */}
            <rect x="14" y="14" width="4" height="2" fill="#444" rx="1" />
            <line x1="15" y1="15" x2="17" y2="15" stroke="#666" strokeWidth="0.5" />
          </svg>
        </div>
      );
    case 'cross':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <line x1="16" y1="10" x2="16" y2="22" stroke={color || "#000000"} strokeWidth="4" />
            <line x1="2" y1="16" x2="30" y2="16" stroke={color || "#000000"} strokeWidth="4" />
          </svg>
        </div>
      );
    case 'directions':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Up Arrow */}
            <path d="M16 2 L12 8 H20 Z" fill={color || "#000000"} />
            <rect x="14" y="8" width="4" height="6" fill={color || "#000000"} />

            {/* Down Arrow */}
            <path d="M16 30 L12 24 H20 Z" fill={color || "#000000"} />
            <rect x="14" y="18" width="4" height="6" fill={color || "#000000"} />

            {/* Left Arrow */}
            <path d="M2 16 L8 12 V20 Z" fill={color || "#000000"} />
            <rect x="8" y="14" width="6" height="4" fill={color || "#000000"} />

            {/* Right Arrow */}
            <path d="M30 16 L24 12 V20 Z" fill={color || "#000000"} />
            <rect x="18" y="14" width="6" height="4" fill={color || "#000000"} />

            {/* Center Dot removed */}
          </svg>
        </div>
      );
    case 'directions_circle':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Surrounding Circle */}
            <circle cx="16" cy="16" r="15" fill="none" stroke={color || "#000000"} strokeWidth="2" />

            {/* Up Arrow */}
            <path d="M16 4 L12 10 H20 Z" fill={color || "#000000"} />
            <rect x="14" y="10" width="4" height="4" fill={color || "#000000"} />

            {/* Down Arrow */}
            <path d="M16 28 L12 22 H20 Z" fill={color || "#000000"} />
            <rect x="14" y="18" width="4" height="4" fill={color || "#000000"} />

            {/* Left Arrow */}
            <path d="M4 16 L10 12 V20 Z" fill={color || "#000000"} />
            <rect x="10" y="14" width="4" height="4" fill={color || "#000000"} />

            {/* Right Arrow */}
            <path d="M28 16 L22 12 V20 Z" fill={color || "#000000"} />
            <rect x="18" y="14" width="4" height="4" fill={color || "#000000"} />
          </svg>
        </div>
      );
    case 'ring':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="14" fill="none" stroke={color || "#000000"} strokeWidth="4" />
          </svg>
        </div>
      );


    case 'ring_dashed':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            {/* Outer Circle */}
            <circle cx="16" cy="16" r="14" fill="none" stroke={color || "#000000"} strokeWidth="2" />

            {/* Dividing Lines */}
            <line x1="16" y1="2" x2="16" y2="30" stroke={color || "#000000"} strokeWidth="2" />
            <line x1="2" y1="16" x2="30" y2="16" stroke={color || "#000000"} strokeWidth="2" />
            <line x1="6.1" y1="6.1" x2="25.9" y2="25.9" stroke={color || "#000000"} strokeWidth="2" />
            <line x1="25.9" y1="6.1" x2="6.1" y2="25.9" stroke={color || "#000000"} strokeWidth="2" />
          </svg>
        </div>
      );
    case 'slash':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <line x1="6" y1="26" x2="26" y2="6" stroke={color || "#000000"} strokeWidth="4" strokeLinecap="round" />
          </svg>
        </div>
      );
    case 'horizontal_bar':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <line x1="4" y1="16" x2="28" y2="16" stroke={color || "#000000"} strokeWidth="4" strokeLinecap="round" />
          </svg>
        </div>
      );
    case 'asterisk':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <g stroke={color || "#000000"} strokeWidth="4" strokeLinecap="round">
              <line x1="16" y1="4" x2="16" y2="28" />
              <line x1="16" y1="4" x2="16" y2="28" transform="rotate(60 16 16)" />
              <line x1="16" y1="4" x2="16" y2="28" transform="rotate(120 16 16)" />
            </g>
          </svg>
        </div>
      );
    case 'arrows_out':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="6" fill="none" stroke={color || "#000000"} strokeWidth="3" />
            <g stroke={color || "#000000"} strokeWidth="3" strokeLinecap="round" fill="none">
              <path d="M16 10 V2 M13 5 L16 2 L19 5" />
              <path d="M16 22 V30 M13 27 L16 30 L19 27" />
              <path d="M10 16 H2 M5 13 L2 16 L5 19" />
              <path d="M22 16 H30 M27 13 L30 16 L27 19" />
            </g>
          </svg>
        </div>
      );
    case 'wheel':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="8" fill="none" stroke={color || "#000000"} strokeWidth="3" />
            <g stroke={color || "#000000"} strokeWidth="3" strokeLinecap="round">
              <line x1="16" y1="4" x2="16" y2="28" />
              <line x1="16" y1="4" x2="16" y2="28" transform="rotate(60 16 16)" />
              <line x1="16" y1="4" x2="16" y2="28" transform="rotate(120 16 16)" />
            </g>
          </svg>
        </div>
      );
    case 'equal':
      return (
        <div className="relative flex items-center justify-center" style={{ width: pixelSize, height: pixelSize }}>
          <svg width="100%" height="100%" viewBox="0 0 32 32">
            <line x1="6" y1="12" x2="26" y2="12" stroke={color || "#000000"} strokeWidth="4" strokeLinecap="round" />
            <line x1="6" y1="20" x2="26" y2="20" stroke={color || "#000000"} strokeWidth="4" strokeLinecap="round" />
          </svg>
        </div>
      );
    default:
      return null;
  }
};

// Backend'de kullanılan gerçek değerler
export const backendSizes = {
  'xxs': 16,
  'xs': 20,
  's': 24,
  'm': 32,
  'l': 40,
  'xl': 48,
  'xxl': 56
};

// Kullanıcıya gösterilecek sayısal değerler
export const displaySizes = {
  '1': 'xxs',
  '2': 'xs',
  '3': 's',
  '4': 'm',
  '5': 'l',
  '6': 'xl',
  '7': 'xxl'
};

// Boyut mapping'i (display -> backend)
export const sizeMapping = {
  '1': 'xxs',
  '2': 'xs',
  '3': 's',
  '4': 'm',
  '5': 'l',
  '6': 'xl',
  '7': 'xxl'
};

// Backend'den gelen değeri display değerine çevir
export const backendToDisplay = (backendSize) => {
  const mapping = {
    'xxs': '1',
    'xs': '2',
    's': '3',
    'm': '4',
    'l': '5',
    'xl': '6',
    'xxl': '7'
  };
  return mapping[backendSize] || '4';
};

// Display değerini backend değerine çevir
export const displayToBackend = (displaySize) => {
  return sizeMapping[displaySize] || 'm';
};

export const markerSizes = backendSizes;

export const markerStyles = [
  {
    type: 'modern',
    name: 'Modern',
    icon: MarkerIcon('modern')
  },
  {
    type: 'arrow',
    name: 'Ok',
    icon: MarkerIcon('arrow')
  },
  {
    type: 'book',
    name: 'Kitap',
    icon: MarkerIcon('book')
  },
  {
    type: 'flag',
    name: 'Bayrak',
    icon: MarkerIcon('flag')
  },
  {
    type: 'mosque',
    name: 'Cami',
    icon: MarkerIcon('mosque')
  },
  {
    type: 'bridge',
    name: 'Köprü',
    icon: MarkerIcon('bridge')
  },
  {
    type: 'house',
    name: 'Ev',
    icon: MarkerIcon('house')
  },
  {
    type: 'horse',
    name: 'At',
    icon: MarkerIcon('horse')
  },
  {
    type: 'ship',
    name: 'Gemi',
    icon: MarkerIcon('ship')
  },
  {
    type: 'explosion',
    name: 'Patlama',
    icon: MarkerIcon('explosion')
  },
  {
    type: 'cross',
    name: 'Artı',
    icon: MarkerIcon('cross')
  },
  {
    type: 'directions',
    name: 'Yön Tuşları',
    icon: MarkerIcon('directions')
  },
  {
    type: 'directions_circle',
    name: 'Halkalı Yön Tuşları',
    icon: MarkerIcon('directions_circle')
  },
  {
    type: 'ring',
    name: 'Halka',
    icon: MarkerIcon('ring')
  },
  {
    type: 'ring_dashed',
    name: 'Dilimli Halka',
    icon: MarkerIcon('ring_dashed')
  },
  {
    type: 'slash',
    name: 'Slaş',
    icon: MarkerIcon('slash')
  },
  {
    type: 'horizontal_bar',
    name: 'Yatay Çubuk',
    icon: MarkerIcon('horizontal_bar')
  },
  {
    type: 'asterisk',
    name: 'Yıldız',
    icon: MarkerIcon('asterisk')
  },
  {
    type: 'arrows_out',
    name: 'Dışa Oklar',
    icon: MarkerIcon('arrows_out')
  },
  {
    type: 'wheel',
    name: 'Çark',
    icon: MarkerIcon('wheel')
  },
  {
    type: 'equal',
    name: 'Eşittir',
    icon: MarkerIcon('equal')
  },

];